/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const BranchInfoList = styled.ul({
  paddingLeft: 0,
  listStyle: 'none',
  display: 'table',
  marginBottom: token('space.200'),
});

export const BranchInfoListItem = styled.li({
  display: 'table-row',
});

export const LeftColumn = styled.div({
  display: 'table-cell',
  textAlign: 'right',
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  marginTop: token('space.200'),
  paddingRight: 0,
  verticalAlign: 'middle',
  paddingTop: token('space.050'),
  paddingBottom: token('space.050'),
});

export const RightColumn = styled.div({
  display: 'table-cell',
  verticalAlign: 'middle',
  maxWidth: '408px',
  paddingLeft: token('space.100'),
  paddingTop: token('space.050'),
  paddingBottom: token('space.050'),
});

// Attempt to match the styles of an AK Button with `appearance="link"` and an icon
export const FormerUser = styled.span({
  alignItems: 'center',
  display: 'flex',
  padding: `${token('space.050')} ${token('space.100')}`,
});

export const FormerUserAvatar = styled.span({
  /* remove phantom padding from AK avatar to center-align vertically */
  lineHeight: 0,
  margin: `0 ${token('space.050')}`,
});

export const FormerUserName = styled.span({
  margin: `0 ${token('space.050')}`,
});

export const RetargetBranch = styled.div({
  marginTop: '-8px',
});

export const ReadContainer = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  width: '100%',
});

export const EditContainer = styled.div({
  minWidth: '250px',
  maxWidth: '408px',
});

export const LinkContainer = styled.div({
  margin: '0 4px',
  padding: '0 8px',
  maxWidth: `${408 - 52}px`,
});

export const LinkTextContainer = styled.div({
  display: 'flex',
  whiteSpace: 'nowrap',
  maxWidth: `${408 - 28}px`,
});

export const LinkTextSpan = styled.span({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontWeight: token('font.weight.medium'),
  fontStyle: 'normal',
});

export const Icon = styled.div({
  marginLeft: 'auto',
  marginRight: 0,
  paddingRight: '4px',
});
